import React from "react";
import classes from './MyButton.module.css';

const MyButton = ({children, to, onClick, ...props}) => {

    return (
        <button {...props} onClick={onClick} className={classes.myBtn}>
            {children}
        </button>
    );
};

export default MyButton;